import Conversation from "../model/Conversation";
import GameConversationMessage from "../model/GameConversationMessage";

export default class NewConversationMessageEvent {
    /**
     * @constructor
     * @param {Conversation} conversation 
     * @param {Array<GameConversationMessage>} messages 
     */
    constructor(conversation, messages) {
        this._type = NewConversationMessageEvent.TYPE;

        this._conversation = conversation;
        this._messages = messages;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }

    get messages() {
        return this._messages;
    }
}

NewConversationMessageEvent.TYPE = "ConversationUpdateEvent";